// components/Registration/ContactDetailsStep.js
import React from "react";
import { TextField } from "@mui/material";
import Autocomplete from "@material-ui/lab/Autocomplete";

export default function ContactDetailsStep({ formData, setFormData, validateError, districts }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  return (
    <div>
      {/* Address */}
      <div style={{ margin: "1em" }}>
        <TextField
          fullWidth
          label="Address"
          name="address"
          value={formData.address}
          onChange={handleChange}
          error={!!validateError.address}
          helperText={validateError.address}
          variant="outlined"
          required
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          InputLabelProps={{
            sx: {
              ".MuiInputLabel-asterisk": {
                color: "red",
                fontSize: "1.2em",
              }
            }
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
        />
      </div>

      {/* City */}
      <div style={{ margin: "1em" }}>
        <Autocomplete
          options={districts || []}
          getOptionLabel={(o) => (o?.title ? o.title : "")}
          getOptionSelected={(option, value) => option?.value === value?.value}
          value={formData.city || null}
          onChange={(e, v) => setFormData((prev) => ({ ...prev, city: v }))}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="City"
              required
              error={!!validateError.city}
              helperText={validateError.city}
              variant="outlined"
              InputLabelProps={{
                sx: {
                  ".MuiInputLabel-asterisk": {
                    color: "red",
                    fontSize: "1.2em",
                  }
                }
              }}
              FormHelperTextProps={{
                style: { fontSize: "14px", color: "red" },
              }}
            />
          )}
        />
      </div>

      {/* Email */}
      <div style={{ margin: "1em" }}>
        <TextField
          fullWidth
          label="Email"
          required
          name="email_id"
          value={formData.email_id}
          onChange={handleChange}
          error={!!validateError.email_id}
          helperText={validateError.email_id}
          variant="outlined"
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          InputLabelProps={{
            sx: {
              ".MuiInputLabel-asterisk": {
                color: "red",
                fontSize: "1.2em",
              }
            }
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
        />
      </div>

      {/* Mobile */}
      <div style={{ margin: "1em" }}>
        <TextField
          fullWidth
          label="Mobile"
          required
          name="mobile_number"
          value={formData.mobile_number}
          onChange={handleChange}
          error={!!validateError.mobile_number}
          helperText={validateError.mobile_number}
          variant="outlined"
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          InputLabelProps={{
            sx: {
              ".MuiInputLabel-asterisk": {
                color: "red",
                fontSize: "1.2em",
              }
            }
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
        />
      </div>

      {/* Expectation */}
      <div style={{ margin: "1em" }}>
        <TextField
          fullWidth
          label="Expectation"
          name="pob"
          value={formData.pob}
          onChange={handleChange}
          variant="outlined"
          error={!!validateError.pob}
          helperText={validateError.pob}
          FormHelperTextProps={{
            style: { fontSize: "14px", color: "red" },
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: '16px',
            }
          }}
        />
      </div>
    </div>
  );
}
